import HOME from './module/home'
import COMMON from './module/common'
import CASHIER from './module/cashier'
import NOTICE from './module/notice'

/**
 *  公用ajax请求方法
 */
const apis = {
    ...COMMON,
    ...HOME,
    ...CASHIER,
    ...NOTICE
}
export default apis
